import { render, staticRenderFns } from "./inputradio.vue?vue&type=template&id=f95f93aa&"
import script from "./inputradio.js?vue&type=script&lang=js&"
export * from "./inputradio.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f95f93aa')) {
      api.createRecord('f95f93aa', component.options)
    } else {
      api.reload('f95f93aa', component.options)
    }
    module.hot.accept("./inputradio.vue?vue&type=template&id=f95f93aa&", function () {
      api.rerender('f95f93aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/inputradio.vue"
export default component.exports